import RequestHandler from "../../../services/RequestHandler";
import ServiceCaller from "../../../services/ServiceCaller";
import i18n from "../../../i18n";

export default class ProductRepository {
    async all(shopId: string, categoryId: string): Promise<any> {
        return await new ServiceCaller().getService().getProducts(shopId, categoryId)
    }

    async loadMore(shopId: string, page: number = 1, categoryId?: string): Promise<any> {
        try {
            return await RequestHandler.get(`${shopId}/products?page=${page}&category_id=${categoryId}`);
        } catch (error) {
            console.error("Error loading more products:", error);
            return {status: false, message: i18n.t("error.loadMoreProductsFailed")};
        }
    }
}